import { 
    API_POSITION_LIST, 
    API_POSITION_TREE_LIST,
    API_POSITION_DELETE, 
    API_POSITION_DETAIL, 
    API_POSITION_SAVE,
    API_POSITION_TREE_DRAG 
} from '@/common/constants';
import { 
    get, 
    post, 
    del, 
    put 
} from '@/utils/http';

export const getPositionList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(API_POSITION_LIST, params);
};

export const getPositionTreeList = (rootId) => {
    return get(API_POSITION_TREE_LIST, rootId ? { rootId } : {});
};

export const getPositionDetail = (positionId) => {
    return get(API_POSITION_DETAIL.replace(':positionId', positionId));
};

export const delPosition = (positionId) => {
    return del(API_POSITION_DELETE.replace(':positionId', positionId));
};

export const savePosition = (position) => {
    if(position.id==undefined||position.id==''){
        return post(API_POSITION_SAVE, position);
    }else{
        return put(API_POSITION_SAVE, position);
    }
    
};

export const updPosition = (position) => {
    return put(API_POSITION_SAVE, position);
};

export const dragPositionTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(API_POSITION_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};
// Position POSITION position



// WEBPACK FOOTER //
// ./src/data-model/system/position-model.js